import React, {useContext} from "react";
import {View, StyleSheet} from "react-native";
import styles from './screen-styles';
import ScreenTemplate from "./ScreenTemplate";
import {getTranslation} from "../helpers/getTranslation";
import PtFileUploader from "../components/pt-file-uploader/pt-file-uploader";
import PtCustomerUpload from "../components/pt-customer-upload/pt-customer-upload";
import {isFeatureAvailable} from "../helpers/isFeatureAvailable";
import UserContext from "../helpers/UserContext";
import PtText from "../components/core/pt-text/pt-text";
import {styleVars} from "../app-style-vars";
import PtCallout from "../components/core/pt-callout/pt-callout";

/** set this to styles.withBoundaries to display borders around container views to visually debug layout overflows */
const showBoundaries = null;

/** actual page content should be put inside ScreenTemplate tag,
 * each component/section wrapped in a
 * <View style={[styles.pageContentSlotContainer, showBoundaries]}> tag
 */

export default function UploadsScreen({navigation, route}:any) {

  const {userData, updateUserData} = useContext(UserContext);

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('orderUploadTXT') ?
          <>
            {userData.orderRestricted ?
              <View>
                <PtText style={fileUploadScreenStyles.uploaderTitle}>
                  {getTranslation('file.upload.title.orders')} {getTranslation('file.upload.subtitle.orders.txt')}
                </PtText>
                <PtCallout type={`warning`}>
                  <PtText>{getTranslation('file.upload.order.restricted.message')}</PtText>
                </PtCallout>
              </View>
              :
              <View>
                <PtFileUploader
                  title={getTranslation('file.upload.title.orders')}
                  subtitle={getTranslation('file.upload.subtitle.orders.txt')}
                  explanationText={getTranslation('file.upload.explanation.orders.txt')}
                  uploadType={'orders'}
                  fileType={'text/plain'}
                  pickerButtonLabel={getTranslation('file.upload.picker.orders.label.txt')}
                  pickerButtonIcon={'document-txt'}
                  successMessage={getTranslation('file.upload.success.message.orders.txt')}
                  showUnauthenticatedMessage={true}
                />
              </View>
            }
          </>
          : null
        }
        {isFeatureAvailable('orderUploadXLS') ?
          <>
            {userData.orderRestricted ?
              <View style={fileUploadScreenStyles.withSeparator}>
                <PtText style={fileUploadScreenStyles.uploaderTitle}>
                  {getTranslation('file.upload.title.orders')} {getTranslation('file.upload.subtitle.orders.xls')}
                </PtText>
                <PtCallout type={`warning`}>
                  <PtText>{getTranslation('file.upload.order.restricted.message')}</PtText>
                </PtCallout>
              </View>
              :
              <View>
                <PtFileUploader
                  title={getTranslation('file.upload.title.orders')}
                  subtitle={getTranslation('file.upload.subtitle.orders.xls')}
                  explanationText={getTranslation('file.upload.explanation.orders.xls')}
                  uploadType={'orders/xls'}
                  fileType={'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
                  pickerButtonLabel={getTranslation('file.upload.picker.orders.label.xls')}
                  pickerButtonIcon={'document-xls'}
                  successMessage={getTranslation('file.upload.success.message.orders.xls')}
                />
              </View>
            }
          </>
          : null
        }
        {isFeatureAvailable('customerUpload') ?
          <PtCustomerUpload explanationText={getTranslation('file.upload.explanation.customers')}></PtCustomerUpload>
          : null
        }
      </View>

    </ScreenTemplate>
  )
}

const fileUploadScreenStyles = StyleSheet.create({
  uploaderTitle: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold',
    paddingBottom: styleVars.rem(.5),
  },
  withSeparator: {
    paddingTop: styleVars.rem(1),
    marginTop: styleVars.rem(.5),
    borderTopWidth: 1,
    borderTopColor: styleVars.boschLightGray,
  },
})
